import { useEffect, useState } from 'react';
import axios from '../helpers/axios'

export const createNewInvoice = async (values, callback) => {
    const res = await axios.post(`/invoice/createinvoice`, values);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response)
    }
}

export const deleteInvoice = async (id, value, callback) => {
    const res = await axios.put(`/invoice/deleteinvoice/${id}`, { updatedBy: value });

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const getInvoiceByInvNo = async (invoiceNo, callback) => {
    await axios.get(`/invoice/getinvoicebyno/${invoiceNo}`).then(res => {
        callback(res.data.response);
    })
}

export const getAllInvoice = async (rowPerPage, pageNumber, search, callback) => {
    const res = await axios.get(`/invoice/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`);

    callback(res.data.response);
}

export const getInvoicesByYear = async (rowPerPage, pageNumber, currentYear, callback) => {
    await axios.get(`/invoice/getinvobyyear/${currentYear}?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}`).then(res => {
        callback(res.data.response);
    })
}

export const getInvoicesByMonth = async (rowPerPage, pageNumber, currentMonth, callback) => {
    await axios.get(`/invoice/getinvobymont/${currentMonth}?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}`).then(res => {
        callback(res.data.response);
    })
}

export const getInvoicesByToday = async (rowPerPage, pageNumber, callback) => {
    const res = axios.get(`/invoice/getallivotoday/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}`);
    callback(res.data.response);
}

export const getInvoicesByDateRange = async (rowPerPage, pageNumber, starDate, endDate, callback) => {
    const res = axios.get(`/invoice/getbydaterange/${starDate}&${endDate}?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}`).then(response => {
        callback(response.data.response);
    })
}

export const getInvoiceById = async (id, callback) => {
    await axios.get(`/invoice/${id}`).then(res => {
        callback(res.data.response);
    })
}

export const getInvoiceNo = async (callback) => {
    const invoiceRes = await axios.get(`/invoice/getinvoice`);
    callback(invoiceRes.data.response.data)
}

export const InvoiceAPI = () => {
    const [invoices, setInvoices] = useState([]);
    const [invoiceDetail, setInvoiceDetail] = useState({});
    const [newInvNo, setNewInvNo] = useState("");

    const [rowPerPage, setRowPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [callback, setCallback] = useState(false);
    const [invoiceId, setInvoiceId] = useState(0);

    useEffect(() => {
        getAllInvoice(rowPerPage, pageNumber, search, res => {
            setInvoices(res);
            setTotalPages(res.totalPages);
        })

        getInvoiceById(invoiceId, res => {
            setInvoiceDetail(res);
        })

        getInvoiceNo(res => {
            setNewInvNo(res)
        })
    }, [callback, rowPerPage, search, pageNumber, invoiceId])

    return {
        invoices: [invoices, setInvoices],
        invoiceDetail: [invoiceDetail, setInvoiceDetail],
        newInvNo: [newInvNo, setNewInvNo],
        invoiceId: [invoiceId, setInvoiceId],
        rowPerPage: [rowPerPage, setRowPerPage],
        search: [setSearch],
        pageNumber: [pageNumber, setPageNumber],
        totalPages: [totalPages, setTotalPages],
        callback: [callback, setCallback]
    }
} 